import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: '이 이미지의 대체 텍스트가 없습니다',
    noAnswers: '답변 옵션이 없습니다. 계속하려면 다음을 클릭하세요.',
    placeholder: '기입해주십시오…',
    pleaseSelect: '선택해주십시오…',
    rotateLandscape: '휴대폰의 방향 잠금을 해제하고 가로로 회전하여 계속하십시오.',
    rotatePortrait: '휴대폰을 가로에서 세로로 회전하십시오.',
    ir: {
      selectWebCam: "웹캠(사용 가능한 경우)을 선택하거나 '검색'을 클릭하여 기기에서 업로드하세요",
      noWebCam: '웹캠을 찾을 수 없습니다',
      accessCamUpload: '카메라 액세스/업로드',
      browse: '검색',
      uploadPhoto: '사진 업로드',
      instead: '대신',
      capture: '캡처',
      somethingWrong: '죄송합니다, 문제가 발생했습니다. 나중에 다시 시도해 주세요',
      couldntRead: '죄송합니다, 코드를 판독하지 못했습니다!',
      couldntProcess: '죄송합니다, 이미지를 처리하지 못했습니다!',
      moveOn: '다시 시도하시거나 사진을 제출하시고 계속 진행하세요',
      tryAgain: '다시 시도해 주세요',
      dataReceived: '데이터를 수신했습니다!',
      enterManually: '다시 시도하시거나 아래에서 수동으로 데이터를 입력하세요',
      positionQR: 'QR 코드를 빨간색 프레임 안에 들어오도록 카메라 앞에 배치하거나 컴퓨터에서 업로드해 주세요.',
      analyzing: '이미지 분석 중입니다, 기댜려 주세요',
      submit: '제출하기',
      startOver: '다시 시작',
      allDone: '완료!',
      cantAnalyze:
        '주의 - 이 이미지를 렌더링할 수 없습니다. 다시 제출하거나 더 일반적인 이미지 형식(JPG, PNG, GIF, BMP)을 선택하세요.',
      wrongFormat:
        '죄송합니다. 이 파일 형식은 지원하지 않습니다. 지원되는 이미지 유형(JPG, PNG, GIF, BMP, TIF, PDF, SVG)을 업로드하세요.'
    },
    vr: {
      noWebCam: '웹캠을 찾을 수 없습니다',
      uploadVideo: '비디오 업로드',
      skip: '건너뛸까요?',
      accessCamUpload: '카메라 액세스/업로드',
      browse: '검색',
      instead: '대신',
      or: '또는',
      stopRecording: '녹화 중지',
      willBeStopped: '5분에 녹화가 멈출 것입니다.',
      stopOnDone: '끝나면 촬영을 멈춰 주십시오!',
      record: '기록하기',
      somethingWrong: '죄송합니다, 문제가 발생했습니다. 나중에 다시 시도해 주세요',
      microphone: '마이크로폰',
      camera: '웹 카메라',
      selectMicrophone: '마이크 선택',
      selectCam: '웹 카메라 선택',
      upload: '업로드',
      playback: '다시 재생',
      stopPlayback: '재생 중지',
      submit: '제출하기',
      startOver: '다시 시작',
      allDone: '완료!',
      alternativeRecordSpan: '컴퓨터 장치에서 당신의 영상을 업로드 해주십시오.<br/>',
      alrenativeRecordHref: ' 당신의 웹캠으로 영상을 녹화할 수도 있습니다.',
      cantAnalyze:
        '주의 - 이 비디오를 렌더링할 수 없습니다. 다시 제출하거나 더 일반적인 동영상 형식(MP4, M4V, WEBPM)을 선택하세요.',
      wrongFormat:
        '죄송합니다. 이 파일 형식은 지원하지 않습니다. 지원되는 동영상 유형(MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)을 업로드하세요.'
    },
    cjc: {
      choose: '선택',
      pleaseChoose: '선택해 주세요',
      this: '이것',
      one: '하나',
      myChoice: '내 선택'
    },
    hm: {
      addComment: '아래에 의견을 추가해주세요 ',
      commentMandatoryPlaceHolder: '필수 의견을 추가해주세요... ',
      commentOptionalPlaceHolder: '선택 의견을 추가해주세요... ',
      dragPin: '드래그해서 위치 조정(정밀하게 핀을 놓기 위한 긴 클릭/탭) ',
      removePin: '이미지를 삭제하려면 바깥으로 드래그하세요. ',
      editComment: '의견을 편집하려면 핀을 클릭/탭하세요. ',
      addPin: '핀을 아래 패널에서 드래그한 후, 이미지에서 선택한 부분에 놓으세요.',
      addPins: '핀들을 아래의 패널에서 드래그한 후, 이미지에서 선택한 부분에 놓으세요.',
      leavePins: (minPoints, maxPoints) =>
        `모든 종류의 핀은 최소 ${minPoints}개 남겨야 하지만 ${maxPoints}개 이상 남기면 안 됩니다.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `핀들은 최소 ${minPoints}개 남겨야 하지만 ${maxPoints}개 이상 남기면 안 됩니다.`,
      leavePinsWithOff: maxPoints =>
        `모든 종류의 핀은 ${maxPoints}개 이상 남기면 안 됩니다. 또는 다음을 클릭하여 건너뛰세요.`,
      leavePinsPerPageWithOff: maxPoints =>
        `핀들은 ${maxPoints}개 이상 남기면 안 됩니다. 또는 다음을 클릭하여 건너뛰세요.`,
      leavePinWithOff: '모든 종류의 핀은 1개 이상 남기면 안 됩니다. 또는 다음을 클릭하여 건너뛰세요.',
      leavePinPerPageWithOff: '핀들은 {max}개 이상 남기면 안 됩니다. 또는 다음을 클릭하여 건너뛰세요.',
      leaveExactlyPin: '모든 종류의 핀을 1개 남겨주세요.',
      leaveExactlyPinPerPage: '핀을 1개 남겨주세요.',
      leaveExactlyPins: maxPoints => `모든 종류의 핀을 ${maxPoints}개 남겨주세요.`,
      leaveExactlyPinsPerPage: maxPoints => ` 핀들을 ${maxPoints}개 남겨주세요.`,
      leaveComment: '이미지 아래에 의견을 남겨주세요.',
      noAnswers: '응답 옵션이 없습니다. 다음을 클릭하여 계속해주세요.',
      outOfPins: '핀을 다 사용했습니다',
      pinsBehavior: '이미지 위에서 움직일 경우 하나의 핀을 놓을 수 있는 강조 표시된 지역이 보일 겁니다.',
      clusters: '이렇게 강조 표시된 지역에는 핀만 놓을 수 있습니다.',
      contentAware: '강조 표시된 지역 안 또는 밖에 핀을 놓을 수 있습니다.'
    },
    mp: {
      expand_note: '확대하려면 이미지 위로 마우스를 가져가거나 클릭하세요.',
      rb_note: rows => `${rows ? '아래에서 ' : ''} 항목별로 1개의 응답만 선택하세요.`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return '적용되는 모든 것을 체크해주세요:'
        } else if (min === max) {
          return `${rows ? '아래에서 ' : ''} 항목별로 ${min}개의 응${min !== 1 ? '답을' : '답만'}선택하세요:`
        } else if (min > 0 && max < 5000) {
          return `${rows ? '아래 각 ' : ''}항목에 대하여 ${min}개 이상, ${max}개 이하의 응답을 선택해 주세요:`
        } else if (5000 === max && min > 0) {
          return `${rows ? '아래 각 ' : ''}항목에 대하여 ${min}개 이상의 응답 을 선택해 주세요:`
        } else if (0 === min && max < 5000) {
          return `${rows ? '아래 각 ' : ''}항목에 대하여 ${max}개 이하의 응답을 선택해 주세요::`
        } else {
          return '적용되는 모든 것을 체크해주세요:'
        }
      }
    },
    sh: {
      note: '확대하려면 제품을 클릭하고 스토어에서 구매하려면 가상 장바구니에 추가하세요.',
      amazonNote: '제품을 클릭하여 확대하고 장바구니에 추가하세요',
      fullCart: '장바구니가 가득 찼습니다!',
      qty: '수량',
      addToCart: '장바구니에 추가',
      each: '각',
      items: '항목',
      deleteFromCart: '삭제',
      next: '다음',
      emptyCard: '장바구니가 비어 있습니다.',
      total: '장바구니',
      clearCart: '장바구니 비우기',
      backToStore: '스토어로 돌아 가기',
      na: '해당 사항 없음',
      maxCartCountError: max => `장바구니에 제품을 ${max}개 이하로 추가하세요.`,
      scrollError: `설문 조사를 진행하려면 좌우로 완전히 스크롤하세요. `,
      maxSpentError: max => `${max} 이상 지출하지 마세요.. `,
      maxProductCountError: max => `각 제품에 대해 장바구니에 ${max} 개 이상의 수량을 추가하지 마세요. `
    },
    rb: {
      note: '오직 개의 아이템을 골라주십시오:'
    },
    vo: {
      note: '영상이 끝날 때까지 시청해주세요'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return '적용되는 모든 것을 체크해주세요:'
        } else if (min === max) {
          return `${min !== 1 ? '아무거나' : '오직'} ${min}개의 아이템을 골라주십시오:`
        } else if (min > 0 && max < 5000) {
          return `각 행당, 최소 ${min}개, ${max}개 이하의 아이템을 골라주십오:`
        } else if (5000 === max && min > 0) {
          return `각 행당, 최소 ${min}개 이하의 아이템을 골라주십오:`
        } else if (0 === min && max < 5000) {
          return `행에서 ${max}개를 넘지 않는 항목을 선택하십시오:`
        } else {
          return '적용되는 모든 것을 체크해주세요:'
        }
      }
    },
    oe: {
      na: '해당 없음',
      note: (min, max, _optional) => {
        if (min === max) {
          return `아무 ${min}글자를 입력해십시오.`
        } else if (min > 0 && max < 5000) {
          return `최소 ${min}, ${max}글자를 입력해주십시오.`
        } else if (5000 === max && min > 0) {
          return `최소 ${min}글자를 입력해주십시오.`
        } else if (0 === min && max < 5000) {
          return `${max}글자 이하로 입력해주십시오.`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: '다음 항목을 작성해 주세요：'
    },
    mx: {
      note: '계속하려면 강조 표시된 슬라이더를 움직이세요',
      dragSlider: '왼쪽이나 오른쪽으로 드래그해서 답해주십시오.'
    },
    psc: {
      dragLeftRight: '왼쪽이나 오른쪽으로 드래그해서 답해주십시오.'
    },
    ps: {
      note: value => `잔여 ${value} 를 아래에 있는 항목에 배분해 주십시오`,
      allDone: '완료!',
      total: `합계:`,
      dragSlider: '왼쪽이나 오른쪽으로 드래그해서 답해주십시오.'
    },
    cx: {
      note: '드롭박스를 열고 자동 스크롤할 답변을 입력하거나 수동으로 선택하십시오.'
    },
    ro: {
      note: '위나 아래로 드래그해서 재주문:'
    },
    md: {
      note1: '귀하의 첫 번째 선택 항목을 클릭/탭하세요 선택을 해제하려면 다시 클릭/탭하세요.',
      note2: '이제 귀하의 마지막 선택 항목을 클릭/탭하세요 선택을 해제하려면 다시 클릭/탭하세요.',
      note3: '감사합니다! 다음 질문을 계속하거나 다시 시작하시려면 선택하지 않은 항목을 클릭/탭하세요.'
    },
    aro: {
      note: '각각 두개 중 하나를 골라주십시오.'
    },
    wd: {
      note: '다음으로 나오는 값이 그 전 값보다 커야합니다.'
    },
    emd: {
      note: '영상이 끝날 때까지 시청해주세요',
      noAnswers: '답변 옵션이 없습니다. 계속하려면 다음을 클릭하세요.',
      start: '시작하려면 길게 클릭하세요.',
      resume: '다시 시작하려면 길게 클릭하세요.',
      continue: '준비됐습니다! <br />계속하려면 다음을 클릭하세요.',
      continueMobile: '준비되었습니다! <br /> 계속하려면 여기를 클릭하세요.',
      training: {
        session: '학습 세션',
        note: '훈련을 마치세요.',
        moveLeft: '다이얼을 왼쪽 끝까지 드래그하세요.',
        moveBottom: '다이얼을 맨 아래로 드래그하세요.',
        moveRight: '이제 다이얼을 오른쪽 끝까지 드래그하세요.',
        moveTop: '이제 다이얼을 맨 위로 드래그하세요.',
        success: '잘 하셨습니다!'
      }
    },
    sft: {
      noAnswers: '답변 옵션이 없습니다. 계속하려면 다음을 클릭하세요.',
      note: '직관적으로 옳다고 생각되는 답변으로 최대한 빨리 답변해주세요.',
      finish: '모두 완료되었습니다! 계속하려면 다음을 클릭하세요.',
      training: {
        start:
          '<p>이것은 여러 단어를 빠르게 보여주는 문제이며 집중력이 필요합니다. ' +
          '대답하려면 신속하게 대응해야 합니다. </p> <p>연습할 준비가 되셨나요?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `"{buttonLeft}" 을(를) 탭하세요.`
            : (mouse ? `"{buttonLeft}" 을(를) 클릭하세요.` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `"{keyBtnLeft}" 키를 누르세요.` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `"{buttonRight}" 을(를) 탭하세요.`
            : (mouse ? `"{buttonRight}" 을(를) 클릭하세요.` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `"{keyBtnRight}" 키를 누르세요.` : ''),
        fail: () => '너무 느립니다.',
        success: () => '훌륭합니다!',
        finish: () =>
          '<p><strong> 뛰어납니다!</strong></p><p>2~3분 동안 집중력을 잃지 않도록 주의하세요.</p><p>준비되면 다음을 클릭하여 시작하세요.</p>'
      },
      buttons: {
        start: '시작하기',
        yesno: {
          left: '네',
          right: '아니오'
        },
        matches: {
          left: '일치시키기',
          right: '일치하지 않음'
        },
        fits: {
          left: '맞음',
          right: '맞지 않음'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
